import InfiniteAjaxScroll from './../plugin/plugin.infinite-ajax-scroll.min.js';

export default class LoadMore {
    constructor() {
        this.init();
    }

    init() {

        if( document.querySelector('body').classList.contains('blog') || document.querySelector('body').classList.contains('archive') ) {
            // --- AJAX SCROLL---
            function noMorePages() {
                document.querySelector(".status").classList.add("d-none");
            }
            // --- AJAX SCROLL BLOG ---
            function initBlogAjaxScroll(id) {
                const container = '.posts'
                window.ias = new InfiniteAjaxScroll(container, {
                    item: '.post',
                    next: '.next',
                    pagination: '.pagination',
                    spinner: {
                        element: '.loader',
                        delay: 1600,
                    },
                    queryParams: function () {
                        return {
                            lastNumber: lastNumber,
                        };
                    }
                });

                ias.on('last', function () {
                    noMorePages(id);
                });
            }
            initBlogAjaxScroll('.posts');
        }

    }
}